import { CountdownTimer } from '@/components/atom/CountdownTimer';
import { Quiz } from '@/utils/http/quiz';
import { FC } from 'react';
import { BiTime } from 'react-icons/bi';

export type DailyMissionTaskProps = {
    quiz?: Quiz;
    endTime?: Date;
    handleAnswer: () => void;
};

const DailyMissionTask: FC<DailyMissionTaskProps> = (props) => {
    const { quiz, endTime } = props;
    const hasExpired = endTime ? new Date() > endTime : false;

    const Question = () => {
        return (
            <div className="flex flex-col justify-center mb-5 text-center">
                <div className="p-6 pt-20 text-left bg--highlight rounded-t-2xl t__heading--h5">Daily Mission</div>
                <div className="flex flex-row items-start justify-start px-4 py-4 gap-x-4">
                    <div className="flex flex-col items-start w-32 gap-y-2">
                        <span className="t__caption--c1 text-grey-30">Time remaining</span>
                        <div className="flex items-center gap-x-1">
                            <BiTime size="28px" />
                            <CountdownTimer endTime={props.endTime} className="text-white t__button--u1" />
                        </div>
                    </div>
                    <div className="h-12 bg-grey-80 w-[1px]"></div>
                    <div className="flex flex-col items-start gap-y-2">
                        <span className="t__caption--c1 text-grey-30">Reward</span>
                        <span className="mt-1 text-white t__button--u1">{`${quiz?.points ?? 0} Points`}</span>
                    </div>
                </div>
                <div className="z-10 px-4 pb-4 mt-2 mr-auto text-left t__subtitle--s2 text-grey-10">{quiz?.name}</div>
                <div className="w-full pt-2 flex flex-col text-left justify-between gap-y-2 z-50 t__caption--c1 text-[#8c95ba] px-4">
                    {quiz?.options &&
                        quiz.options.map((option, index) =>
                            option ? (
                                <div
                                    className="p-2 pointer-events-auto cursor-pointer ring-violet-60 ring-0 rounded-md bg-grey-50 hover:ring-[1px]"
                                    key={index}
                                    onClick={() => {
                                        if (!hasExpired) {
                                            // @ts-ignore
                                            props.handleAnswer(`${index}`);
                                        }
                                    }}
                                >
                                    <span className="text-[#e5e7f0] t__body--b2">{option}</span>
                                </div>
                            ) : null,
                        )}
                </div>
            </div>
        );
    };

    return (
        <div>
            <Question />
        </div>
    );
};
export default DailyMissionTask;
